import {
 useCallback, useEffect, useMemo, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';

import devicesAlarmApi from '@api/devicesAlarmApi';
import devicesActions from '@state/device/actions';
import * as alertsNames from '@pages/Alertas/helpers/defaultAlerts/alertsNames';

function useAlarmRuleItem({ id, name }) {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  // const [loadingDelete, setLoadingDelete] = useState(false);
  const idsInDeleting = useSelector(({ inverters: a }) => a.idsInDeleting);
  const [loadingActive, setLoadingActive] = useState(false);

  const [isAdmin, setIsAdmin] = useState(false);
  const currentUser = useSelector(({ user }) => user);

  const onEditAlarm = useCallback(() => {

    history.push(`/reglas/dispositivos/${id}`);
    // eslint-disable-next-line
  }, [id]);

  const onDeleteAlarm = useCallback(() => {

    // setLoadingDelete(true);
    dispatch(devicesActions.startDeletingAlarm(id));
    devicesAlarmApi
      .deleteAlarmById({ id })
      .then(() => {

        // setLoadingDelete(false);
        dispatch(devicesActions.deleteAlarm(id));
        message.success(t('views.dynamic_alarms.feedbacks.delete_alarms.success_delete_devices'));

      })
      .catch((resError) => {

        // setLoadingDelete(false);
        const { fem } = resError;
        // eslint-disable-next-line no-console
        console.log(t(fem));

      });

  }, [id, t, dispatch]);

  const onSetActive = useCallback(
    (checked) => {

      const body = { is_active: checked };

      setLoadingActive(true);
      devicesAlarmApi
        .partialUpdateAlarm({ id, body })
        .then((response) => {

          const array = [];
          response.bits_error.forEach((condition) => { // conditions

            array.push({ type: condition });

          });
          const action_array = [];
          response.actions.forEach((data) => {

            const action = {
              type: data.type,
              params: {
                recipients: [data.recipients],
              },
            };
            action_array.push(action);

          });
          response.conditions = array;
          response.actions = action_array;

          dispatch(devicesActions.editAlarm(response));
          setLoadingActive(false);

        })
        .catch((resError) => {

          const { fem } = resError;
          message.error(t(fem));
          setLoadingActive(false);

        });

    },
    // eslint-disable-next-line
    [id]
  );

  const loadingDelete = useMemo(() => idsInDeleting.includes(id), [idsInDeleting, id]);

  const isDefaulAlarm = useMemo(() => {

    if (!name) return false;
    return Object.values(alertsNames).includes(name);

  }, [name]);

  const getPermissonCreate = useCallback(() => {

    const currentUserRole = currentUser.role;
      // eslint-disable-next-line
      setIsAdmin(!!(currentUserRole === 'Superadmin' || currentUserRole === 'Admin'));

  }, []);

  useEffect(() => {

    getPermissonCreate();

}, []);

  return {
    onEditAlarm,
    onDeleteAlarm,
    loadingDelete,
    isDefaulAlarm,
    isAdmin,
    onSetActive,
    loadingActive,
  };

}

export default useAlarmRuleItem;
